import { cloneConfig } from './commonEditorModel';

export const requiredEmailShellPlaceholders = [
    '{{customer_first_name}}',
    '{{customer_full_name}}',
    '{{customer_email}}',
    '{{customer_phone}}',
    '{{agent_name}}',
    '{{agent_phone}}'
];

export const requiredEmailShellTextFields = [
    ['storeName', 'Store / dealer name'],
    ['storeAddressLine1', 'Store address line 1'],
    ['storePhone', 'Store phone'],
    ['introHeadline', 'Intro headline'],
    ['introSubheadline', 'Intro subheadline'],
    ['customerIntroText', 'Customer intro text'],
    ['agentContactHeadline', 'Agent contact headline'],
    ['agentContactSubheadline', 'Agent contact subheadline'],
    ['footerPrivacyText', 'Footer privacy label'],
    ['footerContactText', 'Footer contact label'],
    ['footerFindStoreText', 'Footer find store label'],
    ['footerTelusText', 'Footer TELUS label'],
    ['footerLegalText', 'Footer legal block'],
    ['footerFinePrintText', 'Footer fine print block']
];

const isHttpUrl = (value) => {
    try {
        const url = new URL(String(value || '').trim());
        return url.protocol === 'http:' || url.protocol === 'https:';
    } catch (error) {
        return false;
    }
};

export const validateEmailShellEditor = (shell = {}, imageFields = [], socialFields = []) => {
    const errors = [];
    requiredEmailShellTextFields.forEach(([key, label]) => {
        if (!String(shell[key] || '').trim()) {
            errors.push(`${label} is required.`);
        }
    });
    imageFields.forEach(({ key, label }) => {
        if (!isHttpUrl(shell[key])) {
            errors.push(`${label} must be a valid URL.`);
        }
    });
    socialFields.forEach(({ key, label }) => {
        if (!isHttpUrl(shell.socialIconUrls?.[key])) {
            errors.push(`${label} must be a valid URL.`);
        }
    });
    requiredEmailShellPlaceholders.forEach((placeholder) => {
        if (!Array.isArray(shell.requiredPlaceholders) || !shell.requiredPlaceholders.includes(placeholder)) {
            errors.push(`Required placeholder ${placeholder} must remain available.`);
        }
    });
    return errors;
};

export const serializeEmailShellEditor = (sourceConfig, editor) => {
    const nextConfig = cloneConfig(sourceConfig);
    nextConfig.emailShell = {
        ...nextConfig.emailShell,
        ...editor,
        socialIconUrls: {
            ...(nextConfig.emailShell?.socialIconUrls || {}),
            ...(editor.socialIconUrls || {})
        },
        requiredPlaceholders: requiredEmailShellPlaceholders
    };
    return nextConfig;
};
